<section class="container">
    <div class="well well--optin">
        <div>
            <div class="h5">
                U mist onze
                <span class="text text--primary">top-aanbiedingen</span>
                voor InShared klanten!
            </div>
            <p>We sturen u hooguit 1 x per maand een mail en u kunt ze elk moment weer stopzetten.</p>
        </div>
        <div class="well__buttons">
            <button class="btn btn--primary" ins_debounceClick (debounceClick)="changeOptOut(indicationEnum.No)">
                Stuur de mails maar door
            </button>
            <button
                class="btn btn--close"
                type="button"
                aria-label="Annuleren"
                tabindex="-1"
                ins_debounceClick
                (debounceClick)="onCancel()"
            >
                <svg class="svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#cross-closed"></use>
                </svg>
            </button>
        </div>
    </div>
</section>
